import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentFr = () => {
    return (
        <HighlightedText
            text="VOUS AVEZ GAGNÉ 400 TOURS GRATUITS"
            highlights={[{ word: '400' }]}
            breakAfterWords={['GAGNÉ', 'TOURS']}
            className={styles.text_content}
        />
    )
}
